export class Device {
  public id: string;
  public address: number;
  public name: string;
  public isOnline: boolean;
}
